import { useTranslation } from 'react-i18next';
import { ReactElement } from 'react';

import { PRIVACY_POLICY, REFUND_POLICY, TERMS_OF_USE } from 'constants/politics';

import Text from 'components/Text';

import base from 'assets/styles/Common.module.css';

interface IStartPageFooter {
    noRefound?: boolean;
}

export default function StartPageFooter({ noRefound }: IStartPageFooter): ReactElement {
    const { t } = useTranslation();

    return (
        <Text caption centered transparence grey>
            {t('startFlow.startAge.continuingConfirm')}{' '}
            <a
                href={TERMS_OF_USE}
                data-locator="termsOfUseLink"
                className={base.colorMain}
                target="_blank"
                rel="noopener noreferrer"
            >
                {t('basics.termsOfUse')}
            </a>
            ,{' '}
            <a
                href={PRIVACY_POLICY}
                data-locator="privacyPolicyLink"
                className={base.colorMain}
                target="_blank"
                rel="noopener noreferrer"
            >
                {t('basics.privacyPolicy')}
            </a>{' '}
            {!noRefound && (
                <>
                    {t('basics.and')}{' '}
                    <a
                        href={REFUND_POLICY}
                        className={base.colorMain}
                        target="_blank"
                        rel="noopener noreferrer"
                        data-locator="refundPolicyLink"
                    >
                        {t('basics.refundPolicy')}
                    </a>
                </>
            )}
            .
        </Text>
    );
}
